import { FunctionComponent, h } from 'preact';
import SuccessContent from './success-content/success-content';
import ContentWithStatusBar, { BarStatus } from '../modal/content-with-status-bar/content-with-status-bar';
import SlidingContentBox from '../sliding-content-box/sliding-content-box';
import FailContent from './fail-content/fail-content';
import Loading from '../loading/loading';

interface Props {
	closeModal: () => void;
	children?: JSX.Element | JSX.Element[];
	successContent?: JSX.Element;
	isLoading?: boolean;
	modalState: ModalState;
	okText: string | JSX.Element;
	successTitle: string | JSX.Element;
	errorTitle: string | JSX.Element;
	errorDescription: string | JSX.Element;
}

export enum ModalState {
	Idle = 'idle',
	Success = 'success',
	Fail = 'fail'
}

const getBarStatusFromModalState = (pageState: ModalState): BarStatus => {
	switch (pageState) {
		case ModalState.Success:
			return BarStatus.Success;
		case ModalState.Fail:
			return BarStatus.Fail;
		default:
			return BarStatus.None;
	}
};

const getIndexFromModalStatus = status => {
	if (status === ModalState.Success || status === ModalState.Fail) {
		return 1;
	}
	return 0;
};

const ActionModal: FunctionComponent<Props> = ({
	closeModal,
	successContent,
	okText,
	isLoading,
	errorTitle,
	errorDescription,
	successTitle,
	children,
	modalState
}) => {
	const barStatus = getBarStatusFromModalState(modalState);
	const activeIndex = getIndexFromModalStatus(modalState);

	return (
		<div className="action-page-modal" data-testid="action-modal">
			{isLoading && <Loading />}
			<ContentWithStatusBar status={barStatus}>
				<SlidingContentBox activeIndex={activeIndex}>
					{children}
					{modalState === ModalState.Success && (
						<SuccessContent
							children={successContent}
							okText={okText}
							onOk={closeModal}
							title={successTitle}
						/>
					)}
					{modalState === ModalState.Fail && (
						<FailContent
							onOk={closeModal}
							title={errorTitle}
							description={errorDescription}
							okText={okText}
						/>
					)}
				</SlidingContentBox>
			</ContentWithStatusBar>
		</div>
	);
};

export default ActionModal;
